// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"7427eaba","739":"3bb25714"}[chunkId] + ".chunk.js";
};